import { CustomTagProps } from 'rc-select/lib/BaseSelect';
import { AppText } from '../../../AppText/AppText';

export const SelectTagRender = ({ label }: CustomTagProps) => (
    <AppText margin={0} marginLeft={5}>
        {label},
    </AppText>
);
